import React, { Component, Fragment } from 'react';
import ConfigAdmin from '../../config/configAdmin';
import AdminRoutes from '../../Routes/AdminRoutes';
import AnimationLoader from './templates/AnimationLoader';
import Footer from './templates/Footer';
import Navbar from './templates/Navbar';
import Sidebar from './templates/Sidebar';
import { API_MHS, CORE_API_AKADEMIK } from '../../services/key/api';
import { KEY_MHS } from '../../services/key/api_key';
import { viewAkses } from '../../services/api-services/auth';
import Biodata from '../biodata/Biodata';
import { data } from 'jquery';

class Admin extends Component {
    state = {
        isLogin: false,
        akses: true,
        biodata: false,
        infoBiodata: '',
        dataMhs: []
    }

    getAuth = async () => {
        var authId = localStorage.getItem('icmb')
        var nim = localStorage.getItem('nim')
        let maincontent = document.getElementById("main-content")
        maincontent.style.display = "none";
        if (authId === undefined || nim === undefined) {
            window.location.replace('/loadingout')
        } else {
            const validatingID = await API_MHS.get('mhs/di/khs/v' + KEY_MHS + '&idcmb=' + authId)
            const res = await viewAkses(validatingID.data[0].nim)
            const data_mhs = await CORE_API_AKADEMIK.get(`pengajuankrs/data/view?nim=${validatingID.data[0].nim}`)
            if (res) { this.setState({ akses: res.data.access, biodata: res.data.biodata, infoBiodata: res.data.infobio }) }
            if (validatingID.data.length === 0) {
                localStorage.clear()
                window.location.replace('/loadingout')
            } else {
                localStorage.setItem('isLogin', true)
                localStorage.setItem('nim', validatingID.data[0].nim)
                maincontent.style.display = "block";
                this.setState({
                    isLogin: true,
                    dataMhs: {
                        ...validatingID.data[0],
                        kurikulum: data_mhs.data.kurikulum
                    }
                })
            }
        }
    }

    getExpire = () => {
        var authExpiry = localStorage.getItem('auth_expired_date')
        const now = new Date();
        if (now.getTime() > authExpiry) {
            window.location.replace('/loadingout')
        }
    }

    componentDidMount() {
        this.getAuth();
        this.getExpire();
    }

    render() {
        return (
            <Fragment>
                <ConfigAdmin />
                <div className="container-scroller">
                    <Navbar />
                    <div className="container-fluid page-body-wrapper">
                        <Sidebar
                            akses={this.state.akses}
                            biodata={this.state.biodata} />
                        <div className="main-panel">
                            <div className="content-wrapper">
                                {/* admin child routes  */}
                                {this.state.isLogin && this.state.akses && this.state.isLogin && this.state.biodata ? <AdminRoutes dataMhs={this.state.dataMhs} /> :
                                    <Fragment>
                                        {!this.state.akses ?
                                            <div className="container">
                                                <div className="row">
                                                    <div className="col-sm-12">
                                                        <h3 className="h2">
                                                            Akun Simaka Anda di Tutup &#128524;
                                                        </h3>
                                                        <br />
                                                        <p style={{ fontSize: '17px' }}>
                                                            Mohon maaf atas ketidaknyamannya, kami menginformasikan bahwa anda masih memiliki tanggungan biaya,
                                                            akun simaka anda kami tutup sementara,
                                                            silahkan hubungi FO atau dosen wali.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div> :
                                            !this.state.biodata ?
                                                <>
                                                    <div>
                                                        <p style={{ fontSize: '17px' }}>
                                                            Lengkapi biodata anda terlebih dahulu &#128559;, isi semua kolom yang masih kosong, agar anda dapat mengakses menu lainnya. Terimakasih atas kerjasamanya.
                                                        </p>
                                                        <div className="alert alert-warning mt-3" role="alert">
                                                            <b>Catatan Data Kosong : </b>
                                                            <br />
                                                            {this.state.infoBiodata}
                                                        </div>
                                                    </div>
                                                    <br />
                                                    <Biodata />
                                                </>
                                                : null}
                                    </Fragment>
                                }
                            </div>
                            <Footer />
                        </div>
                    </div>
                    <AnimationLoader />
                </div>
            </Fragment>
        );
    }
}

export default Admin;